module.exports = __webpack_public_path__ + "static/media/Eyebrows_grey.b3f3d2de.svg";